import './clientConfirmed.scss';

const clientConfirmedComponent = {
    template: require('./clientConfirmedView.html'),
    controller: () => {},
};

export default angular.module('app.clientConfirmed', [])
    .component('clientConfirmed', clientConfirmedComponent)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/clientConfirmed/clientConfirmedComponent.js